import React from 'react';
import { Col } from 'react-bootstrap';

import Popup from '../../popup-window';
import { DetailPlayer } from '../detail-player';
import { AnswerAR } from '../../questionnaire/answer-ar';
import { roundingDecimalNumber } from '../../../utils/number';
import { ManualScoring } from '../../../types/manual-scoring';
import { GameDocumentContext } from '../../../contexts/game-document';
import { GetResourceValue } from '../../../utils/game-document/resources';
import { TaskContent } from '../../../types/game-document/entities/task-content';

interface TaskARCardContentProps {
  index?: number;
  isEdit?: boolean;
  playerCode?: string;
  playerName?: string;
  dataARMiniGame: any;
  selectedTaskContent?: TaskContent;
  onSubmitScore?: (e: ManualScoring) => void;
}

export const TaskContentARCard: React.FC<TaskARCardContentProps> = ({
  isEdit = true,
  ...props
}) => {
  const [gameDocument] = React.useContext(GameDocumentContext);
  const [selectedAnswer, setSelectedAnswer] = React.useState<ManualScoring>();

  return (
    <Col md={4} className={'p-1'} key={props.index}>
      <div className={'d-flex flex-column'}>
        <span className={'fw-bold'}>{props?.playerName}</span>
        <div className={'card p-3'}>
          <div className={'d-flex flex-column mb-3'}>
            <div className={'d-flex justify-content-between'}>
              <span>
                Task :{' '}
                {GetResourceValue(
                  gameDocument!.gameDocument!,
                  props.selectedTaskContent?.titleResId ?? '',
                  ''
                )}
              </span>
              <span
                className={'text-success'}
                style={{
                  textAlign: 'right'
                }}>
                On-Demand Task
              </span>
            </div>
            <span className={'text-success'}>
              {props.selectedTaskContent?.ARMiniGame + ' (AR)'}
            </span>
          </div>
          <div className={'d-flex w-full justify-content-between'}>
            <div className={'d-flex flex-column'}>
              <small className={'text-muted'}>Score</small>
              <div className={'d-flex'}>
                <h1 className={'text-success mr-3'}>
                  {props.selectedTaskContent?.ARMiniGameSetting?.manualScoring
                    ? 'M'
                    : 'A'}
                </h1>
                <h1 className={'text-dark'}>
                  {roundingDecimalNumber(props.dataARMiniGame.score ?? 0, 2)}
                </h1>
              </div>
            </div>

            <div>
              <a
                href="#"
                className={'cursor-pointer'}
                onClick={() =>
                  setSelectedAnswer({
                    playerCode: props.playerCode,
                    playerName: props.playerName,
                    answer: JSON.stringify(props.dataARMiniGame),
                    taskId: props.selectedTaskContent?.id,
                    formId: props.selectedTaskContent?.id,
                    score: props.dataARMiniGame.score ?? 0,
                    isScored: props.dataARMiniGame.score !== undefined
                  })
                }>
                {isEdit ? 'Edit' : 'View'}
              </a>
            </div>
          </div>
          <div className={'d-flex w-full'}>
            <div className={'flex-grow-1'}>
              <div className={'d-flex flex-column'}>
                <small className={'text-muted mb-2'}>Answer</small>
                <AnswerAR
                  type={props.selectedTaskContent?.ARMiniGame!}
                  contentCenter={false}
                  answerInput={props.dataARMiniGame}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {selectedAnswer && (
        <Popup
          handleClose={() => setSelectedAnswer(undefined)}
          width={'600'}
          className={
            'box assessment-export d-flex flex-column position-relative'
          }>
          <DetailPlayer
            type={'OnDemandTask'}
            dataPlayer={selectedAnswer}
            onSubmitScore={(e) => {
              if (props.onSubmitScore) {
                props.onSubmitScore(e);
                setSelectedAnswer(undefined);
              }
            }}
          />
        </Popup>
      )}
    </Col>
  );
};
